"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanBookingRequest = void 0;
var LoanBookingRequest = /** @class */ (function () {
    function LoanBookingRequest() {
    }
    return LoanBookingRequest;
}());
exports.LoanBookingRequest = LoanBookingRequest;
;
//# sourceMappingURL=loanBooking.request.js.map